// AutoMapper
import { AutoMap } from '@nartc/automapper';

import { Type } from 'class-transformer';

export class InsurerVm {
    @AutoMap() isSosPartner: number;
    @AutoMap() isIag: number;
    @AutoMap() isInsurer: number;
    @AutoMap() id: string;
    @AutoMap() code: string;
    @AutoMap() shortName: string;
    @AutoMap() longName: string;
    @AutoMap() phoneNumber?: any;
}